import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { Grid } from "@material-ui/core";
import { Helmet } from "react-helmet";
import {
  Margin,
  Title,
  Text,
  Message,
  Breadcrumb,
} from "~/components/elements";
import { Header, Footer } from "~/components/blocks";
import { HeroBanner } from "~/components/sections";
import * as S from "./styles";
import { scrollTo } from "~/utils/tools";
import { Creators as SignUpActions } from "~/store/modules/signUp/actions";
import isMobile from "~/hooks/isMobile";
import history from "~/routes/history";

export default function VerifyEmail() {
  const mobile = isMobile();
  const dispatch = useDispatch();
  const userMail = useSelector((state) => state.signUp.sign.userMail);

  const userHash = useSelector((state) => state.signUp.sign.userHash);
  const resending = useSelector((state) => state.signUp.resend.sending);
  const resendSuccess = useSelector((state) => state.signUp.resend.success);
  const resendMessage = useSelector((state) => state.signUp.resend.message);
  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };

  const navBreadcrumb = [
    {
      text: "Início",
      link: "/",
    },
    {
      text: "Verifique",
      link: "/verifique-seu-email",
    },
  ];

  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;

  const handleResend = () => {
    dispatch(SignUpActions.setResendData());
    dispatch(
      SignUpActions.resendConfirmEmail({
        ParticipanteHash: userHash,
        url: url,
        origin: origin,
      })
    );
  };

  useEffect(() => {
    scrollTo(700);
    if (!userMail) {
      history.push({ pathname: "/" });
    }
    return () => {
      dispatch(SignUpActions.setSignUpData());
      dispatch(SignUpActions.setResendData());
    };
  }, [userMail, dispatch]);

  return (
    <>
      <Helmet>
        <title>Bebê Johnson's | Cadastre-se</title>
      </Helmet>
      <Header />
      <HeroBanner />
      <Breadcrumb navBreadcrumb={navBreadcrumb} />
      <motion.div
        variants={animations}
        className="single"
        initial="exit"
        animate="enter"
        exit="exit"
      >
        <S.PageContainer>
          <Grid container justifyContent="center">
            <S.PageHolder>
              <Margin mt={mobile ? 6 : 12} mb={mobile ? 1 : 2}>
                <S.TitleHolder>
                  <Title as="1" levelDesktop="4" level="4">
                    <strong>Verifique seu e-mail</strong>
                  </Title>
                </S.TitleHolder>
              </Margin>
              <Margin mb={mobile ? 3 : 4}>
                <S.TextHolder>
                  <Text level="2">
                    Foi enviada uma mensagem de confirmação para o e-mail
                    cadastrado. <br className="deskOnly" />
                    <Text as="strong" level="2">
                      Confira sua caixa de entrada para validarmos seu cadastro.
                    </Text>
                  </Text>
                </S.TextHolder>
              </Margin>
              <Margin mb={2}>
                <S.Email>
                  Confirmação enviada para: {mobile && <br/>} <strong>{userMail}</strong>
                </S.Email>
              </Margin>
              <Margin mb={mobile ? 9 : 14}>
                <S.TextHolder>
                  <Text level="2">
                    Ainda não recebeu a <br className="mobileOnly" />
                    confirmação de cadastro?
                  </Text>
                  {!resending && (
                    <Text
                      as="anchor"
                      level="2"
                      onClick={() => handleResend()}
                      id="resendLinkValidate"
                    >
                      <Text as="strong" level="2">
                        Clique aqui para reenviar o e-mail
                      </Text>
                    </Text>
                  )}
                  {resendMessage && (
                    <S.Message>
                      <Message variant={resendSuccess ? "success" : "error"}>
                        {resendMessage}
                      </Message>
                    </S.Message>
                  )}
                </S.TextHolder>
              </Margin>
            </S.PageHolder>
          </Grid>
        </S.PageContainer>
      </motion.div>
      <Footer />
    </>
  );
}
